import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-import',
  templateUrl: './confirm-import.component.html',
  styleUrls: ['./confirm-import.component.css']
})
export class ConfirmImportComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<any>, 
              @Inject(MAT_DIALOG_DATA) public data: any) {  
  } 
  
  registros: any[];
  confirmButtonEnabled: boolean = true;

  ngOnInit(): void
  {
    this.registros = this.data.registros;
    this.confirmButtonEnabled = this.data.confirmButtonEnabled;    
  }

  
  cancelar(): void
  {
    this.dialogRef.close(null);
  }

  confirmar(): void
  {
    this.dialogRef.close("confirmado");
  }


}
